// @ts-nocheck
import { useNavigate, useRouteLoaderData } from "react-router-dom";

import { myAxios } from "../common/functions";
import FleetForm from "./fleetForm";
import Inventory from "./inventory";
import Settings from "./settings";
import Yard from "./yard";
import Yards from "./yards";

import { useUiStore } from "src/components/main/uiStore";
function useFleetFormSubmit(closeTo) {
    const navigate = useNavigate();
    const setShowLoader = useUiStore(state => state.setShowLoader);

    return async event => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const fileName = formData.get("url");
        setShowLoader(true);
        const res = await myAxios({ fileName, formData });
        setShowLoader(false);
        if (!res) return;

        const nextId = res.data?.id ?? formData.get("id") ?? "";
        navigate(nextId ? `/Fleets/${nextId}` : closeTo);
    };
}

export function FleetSettingsRoute() {
    const navigate = useNavigate();
    return <Settings tabTitle="Fleets" closeIt={() => navigate("/Fleets")} />;
}

export function FleetYardsRoute() {
    const navigate = useNavigate();
    return <Yards tabTitle="Fleets" closeIt={() => navigate("/Fleets")} />;
}

export function FleetYardRoute() {
    const navigate = useNavigate();
    return <Yard tabTitle="Fleets" closeIt={() => navigate("/Fleets")} />;
}

export function FleetInventoryRoute() {
    const navigate = useNavigate();
    return <Inventory closeIt={() => navigate("/Fleets")} />;
}

export function FleetAddRoute() {
    const navigate = useNavigate();
    const handleSubmit = useFleetFormSubmit("/Fleets");

    return (
        <FleetForm
            users={[]}
            keyword="Add"
            handleSubmit={handleSubmit}
            closeIt={() => navigate("/Fleets")}
            shoulDisable={false}
            postUrl="fleet/createFleet.php"
        />
    );
}

export function FleetEditRoute() {
    const navigate = useNavigate();
    const fleet = useRouteLoaderData("fleet");
    const handleSubmit = useFleetFormSubmit(`/Fleets/${fleet.id}`);

    return (
        <FleetForm
            users={[]}
            keyword="Edit"
            handleSubmit={handleSubmit}
            closeIt={() => navigate(`/Fleets/${fleet.id}`)}
            shoulDisable
            postUrl="fleet/updateFleet.php"
            {...fleet}
        />
    );
}
